import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { ValidateOfflineSupplierNameRequest } from 'src/types/manage-suppliers/OfflineSupplierValidation';
import axiosInstance from 'src/utils/axios';

export const validateOfflineSupplierName = async ({
  supplierName,
  offlineSupplierId,
}: ValidateOfflineSupplierNameRequest): Promise<boolean> => {
  const response = await axiosInstance.get<boolean>(api.validateOfflineSupplierName, {
    params: {
      supplierName,
      ...(offlineSupplierId != null && { offlineSupplierId }),
    },
  });
  return response.data;
};

const useValidateOfflineSupplierNameMutation = () =>
  useMutation({
    mutationFn: validateOfflineSupplierName,
  });

export default useValidateOfflineSupplierNameMutation;
